export default __webpack_public_path__ + "static/media/addcontact_button.634fed7a.svg";